import { useAppointmentSubmitBumbalDate } from "app/hooks/appointment/useAppointmentSubmitBumbalDate";
import { useAnalytics } from "app/hooks/shared/analytics/useAnalytics";
import { useOrderContext } from "app/providers/OrderProvider";
import Button, { ButtonTypes } from "shared/ui/button";

interface AppointmentFooterProps {
  selectedDate: Date | null;
}

const AppointmentFooter = ({ selectedDate }: AppointmentFooterProps) => {
  const { submitBumbalDate, isCreatingBumbalDate } =
    useAppointmentSubmitBumbalDate();
  const { order } = useOrderContext();
  const { onAddInstallationAppointment } = useAnalytics();

  const onSubmit = () => {
    onAddInstallationAppointment(order);
    submitBumbalDate(selectedDate);
  };

  return (
    <footer className="gg-bg-dark-blue gg-px-4 gg-py-11 gg-py-14 gg-text-white sm:gg-px-14 2xl:gg-px-24">
      <Button
        type={ButtonTypes.YELLOW}
        onClick={() => onSubmit()}
        disabled={!selectedDate}
        loading={isCreatingBumbalDate}
      >
        Afspraak bevestigen
      </Button>
    </footer>
  );
};
export default AppointmentFooter;
